<template>
	<div class="wc-step" :class="[{'wc-subtitle': title == true},{'wc-step1': step === 1},{'wc-step2': step === 2},{'wc-step3': step === 3},{'wc-step4': step === 4},{'completed-step': completed == true}]">
		<template v-if="title === true">
			<span class="num">{{step}}. </span>
			<BaseCmsLabel tag="span" :code="'step'+step" class="title" />
		</template>
		<template v-else>
			<BaseUtilsAppUrls v-slot="{items: appUrls}">
				<template v-if="step === 1">
					<component :is="completed == true ? NuxtLink : 'div'" class="step_link" :to="appUrls.webshop_customer">
						<span class="num label">1. </span>
						<BaseCmsLabel tag="span" code="step1" class="title label" />
						<BaseCmsLabel v-if="completed == true" tag="span" class="change-step" code="change_edit_step" />
					</component>
				</template>
				<template v-if="step === 2">
					<component :is="completed == true ? NuxtLink : 'div'" class="step_link" :to="appUrls.webshop_shipping">
						<span class="num label">2. </span>
						<BaseCmsLabel tag="span" code="step2" class="title label" />
						<BaseCmsLabel v-if="completed == true" tag="span" class="change-step" code="change_edit_step" />
					</component>
				</template>
				<template v-if="step === 3">
					<component :is="completed == true ? NuxtLink : 'div'" class="step_link" :to="appUrls.webshop_payment">
						<span class="num label">3. </span>
						<BaseCmsLabel tag="span" code="step3" class="title label" />
						<BaseCmsLabel v-if="completed == true" tag="span" class="change-step" code="change_edit_step" />
					</component>
				</template>
				<template v-if="step === 4">
					<component :is="completed == true ? NuxtLink : 'div'" class="step_link" :to="appUrls.webshop_review_order">
						<span class="num label">4. </span>
						<BaseCmsLabel tag="span" code="step4" class="title label" />
						<BaseCmsLabel v-if="completed == true" tag="span" class="change-step" code="change_edit_step" />
					</component>
				</template>
			</BaseUtilsAppUrls>
		</template>
	</div>
</template>

<script setup>
	import { NuxtLink } from '#components';
	const props = defineProps({
		step: {
			type: null,
			default: false,
		},
		completed:{
			type: Boolean,
			default: false,
		},
		title:{
			type: Boolean,
			default: false,
		},
	});
</script>

<style lang="less" scoped>
	.wc-subtitle{
		font-size: 30px; line-height: 38px; padding-bottom: 8px; font-weight: 300; padding-top: 0;
		@media (max-width: @t){font-size: 26px; line-height: 32px; padding-bottom: 8px;}
		@media (max-width: @tp){font-size: 20px; line-height: 26px; padding-bottom: 10px; font-weight: normal;}
		@media (max-width: @m){padding-right: 15px; padding-left: 15px;}
	}

	.wc-step{
		@media (max-width: @l){min-width: 215px;}
		@media (max-width: @m){margin-left: -15px; margin-right: -15px;}
	}

	.step_link,.step_link2{
		font-size: 30px; line-height: 36px; display: block; color: #9c9ea0; padding: 16px 0; border-bottom: 1px solid var(--borderColor); border-top: 1px solid var(--borderColor); margin-top: -1px; text-decoration: none; font-weight: 300;
		.label{color: rgba(2,2,37,0.5); transition: var(--transition); display: contents;}
		@media(min-width: @h){
			&:hover{
				.label{color: var(--textColor);}
			}
		}
		@media (max-width: @t){font-size: 26px; line-height: 32px; padding: 15px 0;}
		@media (max-width: @tp){font-size: 20px; line-height: 26px; padding: 14px 0; font-weight: normal;}
		@media (max-width: @m){padding: 14px 15px;}
	}
	.completed-step{
		.step_link,.step_link2{
			border-top: 0; display: flex; align-items: center;
			.label{color: var(--primaryColor);}
		}
		.change-step{
			margin-left: auto; position: relative; padding-right: 35px; font-size: 16px; line-height: 23px; font-weight: normal; color: var(--primaryColor); position: relative; text-decoration: underline; text-decoration-color: var(--primaryColor); text-underline-offset: 2px;
			&:after{.pseudo(auto,auto); right: 0; top: 0; .icon-checked(); font: 23px/23px var(--fonti); color: var(--primaryColor);}
		}
		@media(min-width: @h){
			&:hover{
				.change-step{color: #472266; text-decoration: none;}
				.step_link,.step_link2{
					.label{color: #472266;}
				}
			}
		}
		@media (max-width: @t){
			.change-step{
				padding-right: 30px; font-size: 14px; line-height: 20px;
				&:after{font: 20px/20px var(--fonti);}
			}
		}
		@media (max-width: @tp){
			.change-step{
				padding-right: 26px; font-size: 12px; line-height: 18px;
				&:after{font: 18px/18px var(--fonti);}
			}
			.step_link,.step_link2{color: var(--primaryColor);}
		}
		@media (max-width: @m){
			.step_link,.step_link2{
				.label{color: var(--primaryColor);}
			}
		}
	}
</style>
